/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_UpcomingInputs */

const th_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังจะถึง`)
};

const en_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const ja_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開催予定`)
};

const zh_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将开始`)
};

const es_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const pt_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const id_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendatang`)
};

const fr_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À venir`)
};

const tl_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paparating`)
};

const vi_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp tới`)
};

const ko_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예정`)
};

const de_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende`)
};

const ru_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящие`)
};

const tr_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaklaşan`)
};

const it_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In arrivo`)
};

const pl_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadchodzące`)
};

const uk_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найближчі`)
};

const hi_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगामी`)
};

const ar_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قادمة`)
};

const ms_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akan datang`)
};

const bn_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আসন্ন`)
};

const zh_tw2_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將開始`)
};

const zh_hk2_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將開始`)
};

const ur_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آنے والے`)
};

const fa_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیشِ‌رو`)
};

const sw_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yanayokuja`)
};

const nl_tab_upcoming = /** @type {(inputs: Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komt eraan`)
};

/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Tab_UpcomingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_upcoming = /** @type {((inputs?: Tab_UpcomingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_UpcomingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_upcoming(inputs)
	if (locale === "ja") return ja_tab_upcoming(inputs)
	if (locale === "zh") return zh_tab_upcoming(inputs)
	if (locale === "es") return es_tab_upcoming(inputs)
	if (locale === "pt") return pt_tab_upcoming(inputs)
	if (locale === "id") return id_tab_upcoming(inputs)
	if (locale === "fr") return fr_tab_upcoming(inputs)
	if (locale === "tl") return tl_tab_upcoming(inputs)
	if (locale === "vi") return vi_tab_upcoming(inputs)
	if (locale === "ko") return ko_tab_upcoming(inputs)
	if (locale === "de") return de_tab_upcoming(inputs)
	if (locale === "ru") return ru_tab_upcoming(inputs)
	if (locale === "tr") return tr_tab_upcoming(inputs)
	if (locale === "it") return it_tab_upcoming(inputs)
	if (locale === "pl") return pl_tab_upcoming(inputs)
	if (locale === "uk") return uk_tab_upcoming(inputs)
	if (locale === "hi") return hi_tab_upcoming(inputs)
	if (locale === "ar") return ar_tab_upcoming(inputs)
	if (locale === "ms") return ms_tab_upcoming(inputs)
	if (locale === "bn") return bn_tab_upcoming(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_upcoming(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_upcoming(inputs)
	if (locale === "ur") return ur_tab_upcoming(inputs)
	if (locale === "fa") return fa_tab_upcoming(inputs)
	if (locale === "sw") return sw_tab_upcoming(inputs)
	if (locale === "nl") return nl_tab_upcoming(inputs)
	return en_tab_upcoming(inputs)
});